// Mock data for Nu Skin Prysm iO Opportunity Page

export const heroData = {
  title: "The Future of Personal Wellness",
  subtitle: "The truly intelligent device that takes the guesswork out of nutritional wellness.",
  ctaText: "Learn More",
  ctaLink: "#discover"
};

export const supplementsSection = {
  title: "How do you know your nutritional supplements are working?",
  description: "In 2024 alone, consumers spent a staggering $485 billion on nutritional supplements—but most are still asking if they're seeing real results. Prysm iO is the answer. It helps you make smarter health choices by providing realtime insights into your carotenoid absorption—a reflection of your overall antioxidant status and the first step to know if your supplement and lifestyle updates are working for you.",
  features: [
    {
      icon: "smart-device",
      title: "Smart Device",
      iconUrl: "https://media.nuskin.com/m/5e48b42546b51da4/original/smart-device-white-icon.svg"
    },
    {
      icon: "carotenoid",
      title: "Real-Time Carotenoid Insights",
      iconUrl: "https://media.nuskin.com/m/49a5fea3747bc557/original/carotenoids-change-tracking-white-icon.svg"
    },
    {
      icon: "database",
      title: "Leading Antioxidant Database",
      iconUrl: "https://media.nuskin.com/m/d3da1c19f41132/original/antioxidant-database-icon.svg"
    }
  ]
};

export const revolutionSection = {
  title: "A Revolution in Nutritional Health",
  description: "Carotenoids are powerful antioxidants that help protect the body's cells from oxidative stress caused by poor diet, excessive stress, pollution, smoking, lack of sleep, and other unhealthy lifestyle habits. By non-invasively measuring carotenoid levels in the skin, Prysm iO empowers your customers to make smarter, more personalized health decisions—transforming the way they understand and manage their wellness.",
  image: "https://media.nuskin.com/transform/662f9dc1-8114-46fe-adda-4420834e835a/Prysm-iO-4?io=transform:fill,width:700,height:700&format=webp&quality=95&"
};

export const marketStats = {
  title: "Global Connected Health Opportunity",
  description: "With over 30 years of antioxidant expertise—starting with the pioneering LifePak supplement—and one of the world's largest, longest-running antioxidant databases, Nu Skin is uniquely positioned to transform the enormous wellness industry through innovative technology and unmatched insights.",
  modelImage: "https://media.nuskin.com/m/3a93d7fb56af5803/webimage-prysm-io-market-trends-and-opportunity-model-image-transparent.png",
  stats: [
    {
      value: "$9T",
      description: "Global wellness industry has $9T expected growth through 2028",
      source: "Statista, 2024",
      sourceLink: "#"
    },
    {
      value: "$200B",
      description: "Global supplement market is expected to reach $200B in 2025.",
      source: "Nutrition Business Journal, 2022",
      sourceLink: "#"
    },
    {
      value: "$54B",
      description: "Connected wellness solutions market size is $54B with a CAGR of 20.3% from 2024 to 2030.",
      source: "Grand View Research, 2024",
      sourceLink: "#"
    },
    {
      value: "91%",
      description: "91% of consumers are more likely to shop with brands that offer personalized experiences.",
      source: "Forbes, 2020",
      sourceLink: "#"
    },
    {
      value: "$422B",
      description: "7x global AI market growth from $59.67B in 2021 to $422.37B by 2028.",
      source: "Zion Market Research, 2022",
      sourceLink: "#"
    }
  ]
};

export const validationSection = {
  title: "Supplement Validation Matters More Than Ever",
  image: "https://media.nuskin.com/transform/70674598-fce3-4d90-8e71-f5f4c82d4eca/supplements-validation-trends-and-opportunity-model-image?format=webp&quality=95",
  points: [
    "Nearly 40% of people say it's hard to know if they are getting a benefit from their multi-vitamin(1).",
    "44% of Nu Skin Affiliates who sell SCS products reported that more than half of their Nu Skin business is driven by using the scanner(2).",
    "62% of people agreed that they want a multivitamin that is based on the latest science(1)."
  ]
};

export const discoverSection = {
  title: "Discover Prysm iO",
  subtitle: "Prysm iO is a cutting edge testing tool that non-invasively measures carotenoid levels in skin, providing an immediate indication of a person's overall antioxidant levels.",
  howItWorks: {
    title: "How Does It Work?",
    description: "Prysm iO uses 234,000+ hyperspectral absorption measurements per reading to accurately assess skin carotenoid levels. Its patent-pending Spectral Rai technology measures light absorption and applies machine-learning calibration referencing Raman technology to generate your carotenoid score.",
    image: "https://media.nuskin.com/transform/a7275c08-04b0-4c8a-8c2e-d7e03ee5a7d4/Prysm-iO-11?io=transform:fill,width:720,height:460&focuspoint=0.34,0.5&format=webp&quality=95&io=transform:scale,width:600,height:600"
  },
  carotenoids: {
    title: "What Are Carotenoids, And Why Should I Care About Them?",
    description: "Carotenoids are natural antioxidants found in many fruits and vegetables, playing a crucial role in protecting your body from oxidative stress. As powerful antioxidants, they help combat free radical damage and support overall health. Measuring carotenoid levels provides a real-time insight into your antioxidant status, allowing you to track and improve your wellness with targeted nutrition and supplements.",
    image: "https://media.nuskin.com/transform/fa98b7e1-cc62-44b1-a0b8-b4a504baecab/carotenoids-image?format=webp&quality=95",
    ctaText: "LEARN MORE ABOUT ANTIOXIDANTS",
    ctaLink: "#"
  }
};

export const impactFactors = {
  title: "What Impacts Your Carotenoid Score?",
  factors: [
    {
      icon: "dietary",
      title: "Dietary Habits",
      iconUrl: "https://media.nuskin.com/m/4e8893fa65a3ccef/original/dietary-habits-icon-black.svg"
    },
    {
      icon: "supplements",
      title: "Supplements Intake",
      iconUrl: "https://media.nuskin.com/m/704966221938cf01/original/supplements-intake-icon-black.svg"
    },
    {
      icon: "oxidative",
      title: "Oxidative Stress",
      iconUrl: "https://media.nuskin.com/m/f63707ee67e85d3/original/free-radicals-protection-icon-black.svg"
    },
    {
      icon: "bmi",
      title: "BMI",
      iconUrl: "https://media.nuskin.com/m/36359a4a2bdebaf7/original/body-composition-icon-black.svg"
    }
  ]
};

export const wellnessRevolution = {
  title: "Join the Wellness Revolution",
  subtitle: "Position yourself at the forefront of the booming health-tech market with Prysm iO—your competitive edge.",
  steps: [
    {
      number: "1",
      title: "Tap into the $6 Trillion Health Megatrend",
      iconUrl: "https://media.nuskin.com/m/682b5f2ba09e9e3f/original/1.svg"
    },
    {
      number: "2",
      title: "Leverage Breakthrough Technology",
      iconUrl: "https://media.nuskin.com/m/56e0ac79ab05e247/original/2.svg"
    },
    {
      number: "3",
      title: "Harness Certified Product Solutions",
      iconUrl: "https://media.nuskin.com/m/3c876a2123945de/original/3.svg"
    }
  ]
};

export const ctaSection = {
  title: "15 Seconds Can Change Your Life",
  description: "Unlock the future of personalized wellness with Prysm iO—Nu Skin's game-changing innovation. Join us as a Nu Skin Affiliate to get exclusive early access, the latest updates, and powerful tools to help grow your business with this revolutionary technology.",
  ctaText: "Join Us",
  ctaLink: "#",
  image: "https://media.nuskin.com/transform/81db9269-cec4-4b77-a0ad-b0c95666d663/prysm-io-opportunity-banner-model-image?format=webp&quality=95"
};

export const footerNotes = [
  "(1)Source: Multi-vitamin A&U Report, 2017.",
  "(2)Source: Pharmanex Biophotonic Scanner Use and Value Survey."
];

export const navigation = {
  logo: "NU SKIN",
  regionText: "Select Another Region",
  menuItems: [
    { label: "Beauty Devices", href: "#" },
    { label: "Skin & Beauty", href: "#" },
    { label: "Body Care", href: "#" },
    { label: "Monthly Promotion", href: "#" }
  ],
  breadcrumb: [
    { label: "Home", href: "/" }
  ]
};
